import { render } from "./correction.vue?vue&type=template&id=fa763cf0"
import script from "./correction.vue?vue&type=script&lang=js"
export * from "./correction.vue?vue&type=script&lang=js"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__